import { render, staticRenderFns } from "./OutputAuditRecruitment.vue?vue&type=template&id=4636af72&scoped=true"
import script from "./OutputAuditRecruitment.vue?vue&type=script&lang=js"
export * from "./OutputAuditRecruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636af72",
  null
  
)

export default component.exports